import { render, staticRenderFns } from "./AccountingPage.vue?vue&type=template&id=2eb64207&"
import script from "./AccountingPage.vue?vue&type=script&lang=js&"
export * from "./AccountingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports